import { InstrumentType } from '@cash-web/protos/squareup/common/instrument.pb'

export const cardBrandMap: Partial<Record<InstrumentType, string>> = {
  VISA: 'Visa',
  MASTER_CARD: 'MasterCard',
  AMERICAN_EXPRESS: 'American Express',
  DISCOVER: 'Discover',
  DISCOVER_DINERS: 'Diners Club',
  JCB: 'JCB',
  UNKNOWN: '',
}
